// extracted by mini-css-extract-plugin
export default {"root":"NetworkError-root-fda2c69c8698a9fb78c1009e60464339"};